import PageWrapper from '@/components/PageWrapper';
import { SindiButton } from '@/components/button/SindiButton';
import { Box, Card, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { LuLock, LuMail } from 'react-icons/lu';

function FeatureGate() {
  const { t } = useTranslation('common');

  return (
    <PageWrapper>
      <Flex justify="center" pt={{ base: 8, md: 16 }}>
        <Card.Root maxW="lg" w="100%">
          <Card.Body
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={5}
            py={10}
            px={8}
          >
            <Box
              bg="sindiPurple.100"
              color="sindiPurple.600"
              borderRadius="full"
              p={4}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={LuLock} boxSize={7} />
            </Box>
            <Box textAlign="center">
              <Text
                fontSize="xl"
                fontFamily="merriweather"
                fontWeight="normal"
                mb={2}
              >
                {t('featureNotIncluded')}
              </Text>
              <Text color="gray.500" fontSize="sm">
                {t('featureNotIncludedDescription')}
              </Text>
            </Box>
            <Link
              href="mailto:contact@sindi.se"
              _hover={{ textDecoration: 'none' }}
            >
              <SindiButton colorPalette="sindiPurple" variant="solid">
                <Icon as={LuMail} />
                {t('contactUs')}
              </SindiButton>
            </Link>
            <Link color="gray.500" fontSize="xs" href="mailto:contact@sindi.se">
              contact@sindi.se
            </Link>
          </Card.Body>
        </Card.Root>
      </Flex>
    </PageWrapper>
  );
}

export default FeatureGate;
